const Add_Icon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="white" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 22C15.5523 22 16 21.5523 16 21V16H21C21.5523 16 22 15.5523 22 15C22 14.4477 21.5523 14 21 14H16V9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9L14 14H9C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H14L14 21C14 21.5523 14.4477 22 15 22Z"
        fill="#006A76"
      />
    </svg>
  );
};

export default Add_Icon;
